import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const rootStyles = css`
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  height: 100%;
`;

export const noImageStyle = css`
  aspect-ratio: 16/9;
  background-color: #333;
  border: 1px solid #fff;
  color: #fff;
  display: grid;
  font-size: 16px;
  font-weight: 700;
  height: auto;
  place-items: center;
  width: 100%;
`;

export const mainVisualWrapperStyle = css`
  & img {
    display: block;
    height: auto;
    max-width: 100%;
    width: 100%;
  }
`;

export const descriptionWrapperStyle = css`
  background-color: #fff;
  display: grid;
  padding: 16px;

  ${MEDIA_QUERY_FOR_PC} {
    row-gap: 8px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    row-gap: 10px;
  }
`;
